import { gql } from '../../../__generated__/graphql/catalog'

/**
 * Variant/group fields shared by every cart-surface query
 * (`FETCH_CART_VARIANTS` and `FETCH_CART_EMBROIDERY_CONFIG`). Kept here as the
 * single source of truth so the two queries can't drift out of sync. Surface-
 * specific fields (cart display fields, the embroidery sub-tree) are selected
 * alongside the spread in each query rather than added here.
 */
export const cartVariantCoreFields = gql(`
  fragment CartVariantCoreFields on ProductCatalogVariant {
    id
    sku
    shopifyId
    shopifyProductId
    price {
      amount
      currencyCode
    }
    compareAtPrice {
      amount
    }
    group {
      id
      title
      finalSale
      siteWidePromoEligible
      primaryCategory {
        id
        key
        displayValue
      }
      color {
        id
        displayValue
      }
      product {
        id
        handle
      }
    }
  }
`)

/**
 *  Under `embroidery.options` we only probe each type's `__typename` to derive the
 *  which types are "embroiderable" for this product variant
 */
export const FETCH_CART_VARIANTS = gql(`
  query GetCartVariants($skus: [String!]) {
    productCatalogVariants(skus: $skus) {
      ...CartVariantCoreFields
      availability
      stockState
      urlPath
      fit {
        id
        displayValue
      }
      size {
        id
        displayValue
      }
      group {
        embroidery {
          options {
            icon {
              __typename
            }
            logo {
              __typename
            }
            text {
              __typename
            }
          }
        }
        images(first: 1) {
          url
        }
        exclusive
        gender
      }
    }
  }
`)
